<template>
  <div
    :ref="refName"
    class="
      position-absolute
      showAboveCanvas
      p-3
      pb-5
      text-start text-white
      start-0
      bottom--100
    "
  >
    <div class="bg-translucent-black mt-4 p-3 position-relative">
      <div class="opacity-100">
        <p class="h4">
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  name: "OverlayMessage",
  props: {
    id: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  mounted() {
    // Add message and then remove after 5 seconds
    this.animateIn();
    setTimeout(() => {
      this.animateOut();
    }, 5000);
  },
  computed: {
    refName() {
      return `messageOverlay${this.id}`;
    }
  },
  methods: {
    animateIn() {
      gsap.to(this.$refs[this.refName], {
        bottom: "0%",
        opacity: 1,
        duration: 0.3,
        ease: "sine.out"
      });
    },
    animateOut() {
      // animate message up and out of view
      gsap.to(this.$refs[this.refName], {
        bottom: "10%",
        opacity: 0,
        duration: 0.3,
        ease: "sine.in"
      });
    }
  },
  watch: {
    index: function (newVal, oldVal) {
      if (oldVal === 0 && newVal !== oldVal) {
        console.log("animate out");
        this.animateOut();
      }
    }
  }
};
</script>

<style scoped>
.bg-translucent-black {
  background-color: rgba(0, 0, 0, 0.7);
}
.bottom--100 {
  bottom: -10%;
}
</style>
